import React from 'react';
import { ListFieldSection } from 'Components/Layout';
import { withInjectedProps, NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { Field, TextOutput } from 'Components/Core';
import {
  IWithWorksheetInjectedProps,
  WorksheetResultsSection,
  WorksheetsResultsMessagesSection,
} from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import AtterbergLimitChartSection from '../../Shared/ChartSection';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';

const contextCaptions = [
  { path: `data.LiquidLimit.Trials`, caption: 'Liquid Limit' },
  { path: `data.PlasticLimit.Trials`, caption: 'Plastic Limit' },
  { path: `data.Preparation.AssociatedAsReceivedWaterContent`, caption: 'As-Received Moisture Content' },
];

let ResultsSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const llNonPlastic = useSelector(pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false)));
  const plNonPlastic = useSelector(pipe(createWorksheetSelector!('PlasticLimit.NonPlastic'), valueOrDefault(false)));

  return (
    <WorksheetResultsSection heading="Results">
      <NamePrefixModifier namePrefix="plasticityChart">
        <AtterbergLimitChartSection wide visible={!llNonPlastic && !plNonPlastic} height={400} />
      </NamePrefixModifier>
      <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} />
      <ListFieldSection heading="Results">
        <Field input={<TextOutput />} label="Liquid Limit" name="Results.LiquidLimitText" />
        <Field input={<TextOutput />} label="Plastic Limit" name="Results.PlasticLimitText" />
        <Field input={<TextOutput />} label="Plasticity Index" name="Results.PlasticityIndexText" />
      </ListFieldSection>
    </WorksheetResultsSection>
  );
};

ResultsSection = withInjectedProps(ResultsSection);

export { ResultsSection };
export default ResultsSection;
